"use client";

import { ChevronLeft } from "lucide-react";
import { Button } from "@/shadcn-components/ui/button";
import { Badge } from "@/shadcn-components/ui/badge";
import {
  getDrawingDefinition,
  getDrawingName,
} from "@/lib/chart-drawings/registry";
import { getCategoryLabel } from "@/lib/chart-drawings/catalog";
import type { DrawingInstance } from "@/lib/chart-drawings/types";
import BaseDrawingConfig from "./BaseDrawingConfig";

interface DrawingConfigScreenProps {
  drawing: DrawingInstance;
  onBack: () => void;
  onSave: (updated: DrawingInstance) => void;
}

export default function DrawingConfigScreen({
  drawing,
  onBack,
  onSave,
}: DrawingConfigScreenProps) {
  const def = getDrawingDefinition(drawing.type);
  const displayName = drawing.name || getDrawingName(drawing.type);
  const categoryLabel = def ? getCategoryLabel(def.category) : null;

  return (
    <div className="h-full bg-background text-foreground flex flex-col min-h-0">
      <div className="flex items-start gap-2 px-3 py-2.5 border-b border-border shrink-0">
        <Button
          variant="ghost"
          size="icon"
          onClick={onBack}
          className="h-8 w-8 shrink-0 mt-0.5"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <div className="flex-1 min-w-0 pr-1">
          <p className="text-[10px] uppercase tracking-wide text-muted-foreground font-medium">
            Edit drawing
          </p>
          <h1 className="text-sm font-semibold truncate leading-tight">
            {displayName}
          </h1>
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            <Badge
              variant="secondary"
              className="text-[10px] font-normal h-5 capitalize"
            >
              {getDrawingName(drawing.type)}
            </Badge>
            {categoryLabel ? (
              <Badge
                variant="outline"
                className="text-[10px] font-normal h-5"
              >
                {categoryLabel}
              </Badge>
            ) : null}
          </div>
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
        <BaseDrawingConfig drawing={drawing} onBack={onBack} onSave={onSave} />
      </div>
    </div>
  );
}
